var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("sprint-filter", {
        attrs: { loading: _vm.loading },
        on: {
          "filter-changed": function($event) {
            _vm.filterType = $event
          },
          refresh: _vm.refresh
        }
      }),
      _vm._v(" "),
      _c("box", [
        _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
          _c("i", { staticClass: "fab fa-jira" }),
          _vm._v(
            " " + _vm._s(_vm.resource("SprintPlanning_Index_Issues_Header"))
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "body" }, slot: "body" },
          [
            _c("sprint", {
              ref: "sprint",
              attrs: { filterType: _vm.filterType },
              on: {
                loading: function($event) {
                  _vm.loading = $event
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }